import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { UnverifiedPartsDataGrid } from "src/components/views/erp/parts/unverifiedParts/UnverifiedPartsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/unverifiedParts")({
	staticData: { title: i18n.t("unverified_parts"), legacyViewKey: "unverifiedPartsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <UnverifiedPartsDataGrid />;
}
